/* AnnouncementModal.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "._1bsb1ogm{width:600px}";
const _11 = "._4t3i7rrr{height:275px}";
const _10 = "._2rko1k7a{border-radius:3px 3px 0 0}";
const _9 = "._y3gn1h6o{text-align:center}";
const _8 = "._1yt41ejb{padding:var(--ds-space-300,24px)}";
const _7 = "._4t3i12it{height:75%}";
const _6 = "._t9eczr6s{transform:translateX(-50%)}";
const _5 = "._1ltv1ssb{left:50%}";
const _4 = "._154i1wqb{top:60px}";
const _3 = "._kqswstnw{position:absolute}";
import Button, { ButtonGroup } from '@atlaskit/button';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { H4 } from '@atlassian/amkt-common';
import { hooks } from '@atlassian/mpac-utils';
import React from 'react';
import { categoriesAnnouncementMessage } from './AnnouncementModal.constants';
import bigNews from './big-news.png';
import tealBackgroundImg from './teal-background.png';
const _2 = "._kqswh2mm{position:relative}";
const ImageContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqswh2mm", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ImageContainer.displayName = 'ImageContainer';
}
const Illustration = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqswstnw _154i1wqb _1ltv1ssb _t9eczr6s _4t3i12it", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Illustration.displayName = 'Illustration';
}
const Container = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_8, _9]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1yt41ejb _y3gn1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const BackgroundImage = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "img",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_10, _11, _12]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2rko1k7a _4t3i7rrr _1bsb1ogm", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  BackgroundImage.displayName = 'BackgroundImage';
}
const AnnouncementModal = () => {
  const {
    state,
    writeState
  } = hooks.useLocalStorage('newCategoriesAnnouncementSeen', false);
  const shouldShowModal = !state;
  const onClose = () => {
    writeState(true);
  };
  const onLearnMore = () => {
    onClose();
    window.open('https://developer.atlassian.com/platform/marketplace/new-app-categorization-system-in-marketplace/', '_blank');
  };
  return /*#__PURE__*/React.createElement(ModalTransition, null, shouldShowModal && /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement(BackgroundImage, {
    alt: "A teal background image",
    src: tealBackgroundImg
  }), /*#__PURE__*/React.createElement(Illustration, {
    alt: "Graphic showing that it is a big news",
    src: bigNews
  })), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(H4, null, categoriesAnnouncementMessage.header), categoriesAnnouncementMessage.body, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle-link",
    onClick: _ => onClose()
  }, categoriesAnnouncementMessage.leftButton), /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    autoFocus: true,
    onClick: () => onLearnMore()
  }, categoriesAnnouncementMessage.rightButton)))));
};
export default AnnouncementModal;